import { usePathname, useSearchParams } from "next/navigation";

//

/**
 * @example
 * const url = useUrl() // returns "/dashboard/product/1?foo=bar" on /dashboard/product/1?foo=bar
 */

export function useUrl() {
  const pathname = usePathname();
  const searchParams = useSearchParams().toString();

  if (!searchParams) return pathname;
  return pathname + "?" + searchParams;
}
